import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 900px) {
        flex-direction: column;
        align-items: start;
    }
`;

export const Title = styled.div``;

export const H4 = styled.p`
    font-size: 24px;
`;

export const H6 = styled.p`
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const ContentFilter = styled.div`
    display: flex;
    gap: 16px;
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    padding: 8px;
    
    border-radius: 4px;
    gap: 8px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const Input = styled.input`
    display: none;
`;
export const LabelDate = styled.label``;